// src/pages/QuickstartPage.tsx — Site officiel Vanessa : première requête en 5 minutes
import { Link } from 'react-router-dom';
import { Container, PageHeader, Steps, CodeBlock, InlineCode, Section, CtaBand } from '@/components/site/blocks';
import { VANESSA_API_URL } from '@/api/constants';

export default function QuickstartPage() {
    const apiUrl = VANESSA_API_URL || 'https://api.kinemaplus.com';

    return (
        <>
            <PageHeader eyebrow="Développeurs" title="Votre première requête en 5 minutes" intro="Du compte à la première réponse de Vanessa." />
            <Section>
                <Container className="!px-0 max-w-3xl">
                    <Steps
                        items={[
                            { title: 'Créez un compte', text: <>Rendez-vous sur <Link className="font-semibold text-ochre underline" to="/inscription">l’inscription</Link> et confirmez votre email.</> },
                            { title: 'Demandez une clé', text: <>Dans la <Link className="font-semibold text-ochre underline" to="/console">console</Link>, indiquez le montant proposé et le volume de tokens souhaité. Nous vous recontactons pour confirmer le paiement.</> },
                            { title: 'Copiez votre clé', text: 'Une fois activée, la clé n’est affichée qu’une seule fois. Gardez-la côté serveur, jamais dans un code public.' },
                            { title: 'Envoyez une requête', text: <>Ajoutez la clé dans l’en-tête <InlineCode>x-api-key</InlineCode> et envoyez vos messages.</> },
                        ]}
                    />

                    <h2 className="mt-12 font-display text-2xl font-bold text-ink">cURL</h2>
                    <CodeBlock label="cURL">{`curl ${apiUrl}/v1 \\
  -H "x-api-key: cp_live_votre_cle" \\
  -H "Content-Type: application/json" \\
  -d '{"messages":[{"role":"user","content":"Raconte-moi un ragot"}]}'`}</CodeBlock>

                    <h2 className="mt-8 font-display text-2xl font-bold text-ink">JavaScript</h2>
                    <CodeBlock label="JavaScript">{`const response = await fetch("${apiUrl}/v1", {
  method: "POST",
  headers: {
    "x-api-key": "cp_live_votre_cle",
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    messages: [{ role: "user", content: "Salut Vanessa !" }],
  }),
});

const data = await response.json();
console.log(data.reply);`}</CodeBlock>

                    <h2 className="mt-8 font-display text-2xl font-bold text-ink">Python</h2>
                    <CodeBlock label="Python">{`import requests

response = requests.post(
    "${apiUrl}/v1",
    headers={"x-api-key": "cp_live_votre_cle"},
    json={"messages": [{"role": "user", "content": "Salut Vanessa !"}]},
)

print(response.json()["reply"])`}</CodeBlock>

                    <h2 className="mt-8 font-display text-2xl font-bold text-ink">La réponse</h2>
                    <CodeBlock label="JSON">{`{
  "reply": "Wèèh ça va, et toi ?",
  "usage": {
    "input_tokens": 24,
    "output_tokens": 18,
    "total_tokens": 42,
    "tokens_remaining": 999958
  }
}`}</CodeBlock>
                    <p className="mt-4 text-lg text-gray-700">
                        Pour aller plus loin (historique, champ <InlineCode>context</InlineCode>, erreurs), consultez la{' '}
                        <Link className="font-semibold text-ochre underline" to="/documentation">documentation</Link>.
                    </p>
                </Container>
            </Section>
            <CtaBand title="Prêt à demander votre clé ?" primary={{ label: 'Ouvrir la console', to: '/console' }} secondary={{ label: 'Voir les tarifs', to: '/tarifs', variant: 'secondary' }} />
        </>
    );
}
